// frontend/src/App.jsx
import React from "react";
// Correct imports for react-router-dom v6
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import DashboardPage from "./pages/DashboardPage";
import TradeHistoryPage from "./pages/TradeHistoryPage";
import BotSettingsPage from "./pages/BotSettingsPage";
import "./App.css";

function App() {
  return (
    // Use BrowserRouter directly
    <BrowserRouter>
      <div>
        <nav
          style={{
            marginBottom: "20px",
            background: "#f0f0f0",
            padding: "10px",
          }}
        >
          <ul
            style={{
              listStyleType: "none",
              padding: 0,
              margin: 0,
              display: "flex",
            }}
          >
            <li style={{ marginRight: "15px" }}>
              <Link to="/">Dashboard</Link>
            </li>
            <li style={{ marginRight: "15px" }}>
              <Link to="/history">Trade History</Link>
            </li>
            <li>
              <Link to="/settings">Bot Settings</Link>
            </li>
          </ul>
        </nav>

        {/* Routes component wraps individual Route components */}
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/history" element={<TradeHistoryPage />} />
          <Route path="/settings" element={<BotSettingsPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
